module.exports = __webpack_public_path__ + "img/icon_1_32.3ad8b0db.png";